<template>
  <work-order-card>
    <h3 slot="card-header">基础信息</h3>
    <div slot="card-body" class="work-order-base-info-root">
      <el-form :label-width="labelWidth" :model="workOrder">
        <template v-if="isSealQualificationHandler">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="申请人：">
                {{ sealQualificationDisplay.applicantName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作地点：">
                {{ sealQualificationDisplay.workLocation }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务线：">美呗</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电子邮件：">
                {{ sealQualificationDisplay.applicantEmail }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="使用开始时间：">
                {{ formatYmdCn(sealQualificationDisplay.startTime) }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="使用结束时间：">
                {{ formatYmdCn(sealQualificationDisplay.endTime) }}
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else-if="isAccountCreationHandler">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="申请人：">
                {{
                  workOrder.submitterPeoples &&
                  workOrder.submitterPeoples.userName
                }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请部门：">
                {{ accountCreationDisplay.applyDeptLabel }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请日期：">
                {{ formatYmdCn(accountCreationDisplay.applyDate) }}
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </template>
        <template v-else>
          <el-form-item label="工单编号：">
            {{ workOrder.wkOrderId }}
          </el-form-item>
          <el-form-item label="工单类型：">
            {{ workOrder.qaTypeName }}
          </el-form-item>
          <el-form-item label="问题标题：">
            {{ workOrder.wkOrderTopic }}
          </el-form-item>
          <el-form-item label="问题描述：">
            {{ workOrder.remark }}
          </el-form-item>
          <el-form-item label="提交时间：">
            {{ workOrder.submitTime }}
          </el-form-item>
          <el-form-item label="图片：" v-if="imgList.length">
            <div class="image-list">
              <el-image
                v-for="(item, index) in imgList"
                :key="index"
                :src="item"
                :preview-src-list="imgList"
              ></el-image>
            </div>
          </el-form-item>
          <el-form-item label="附件：" v-if="fileList.length" class="no-wrap">
            <template v-for="(item, index) in fileList">
              <span style="color: rgb(96, 98, 102); margin-left: 10px">
                <i class="el-icon-document"></i> {{ item.fileName }}
              </span>
              <el-button type="text" @click="downloadFile(item)">
                点击下载
              </el-button>
            </template>
          </el-form-item>
          <el-form-item label="附件：" v-if="chatList.length" class="no-wrap">
            <template v-for="(item, index) in chatList">
              <el-button type="text">呗呗聊天记录</el-button>
              <el-button type="text" @click="showChatLog(item)"
                >点击查看</el-button
              >
            </template>
          </el-form-item>
          <el-dialog title="呗呗聊天记录" :visible.sync="chatDialog">
            <chat-log
              :chatId="chatConfig.chatId"
              :userId="chatConfig.userId"
              v-if="chatDialog"
            ></chat-log>
          </el-dialog>
          <el-form-item
            v-if="workOrder.approver && workOrder.approver.userName"
            label="当前审批人："
          >
            {{ workOrder.approver.userName }}
          </el-form-item>
          <el-form-item label="当前承接人：">
            {{
              workOrder.acceptUsers &&
              workOrder.acceptUsers.map((item) => item.userName).join(", ")
            }}
          </el-form-item>
        </template>
      </el-form>
    </div>
  </work-order-card>
</template>

<script>
import { saveAs } from "file-saver";
import chatLog from "../workOrderDetail/chatLog";
import api from "plus/api";

export default {
  name: "workOrderBaseInfo",
  components: { "chat-log": chatLog },
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
    labelWidth: {
      type: String,
      default: "110px",
    },
  },
  data() {
    return {
      chatDialog: false,
      chatConfig: {
        chatId: "",
        userId: "",
      },
    };
  },
  methods: {
    formatYmdCn(val) {
      if (val == null || val === "") {
        return "";
      }
      let ms;
      if (typeof val === "number" && Number.isFinite(val)) {
        ms = Math.abs(val) > 1e11 ? val : val * 1000;
      } else if (typeof val === "string") {
        const s = val.trim();
        if (/^\d{13}$/.test(s)) {
          ms = parseInt(s, 10);
        } else if (/^\d{10}$/.test(s)) {
          ms = parseInt(s, 10) * 1000;
        } else {
          ms = Date.parse(s);
        }
      } else {
        ms = Date.parse(String(val));
      }
      if (!Number.isFinite(ms) || Number.isNaN(ms)) {
        return String(val);
      }
      const d = new Date(ms);
      if (Number.isNaN(d.getTime())) {
        return String(val);
      }
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}年${m}月${day}日`;
    },
    showChatLog(item) {
      this.chatConfig = {
        userId: this.workOrder.customerList[0].businessId,
        chatId: item.appendisUrl,
      };
      this.chatDialog = true;
    },
    remind() {
      api.workmanage.remind(this.wkOrderId).then((res) => {
        this.$message.success("提醒成功！");
        this.$emit("remind");
      });
    },
    downloadFile(item) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", item.url, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          saveAs(xhr.response, item.fileName);
        }
      };
      xhr.send();
    },
  },
  computed: {
    isSealQualificationHandler() {
      return this.workOrder.handlerType === "SEAL_QUALIFICATION";
    },
    isAccountCreationHandler() {
      return this.workOrder.handlerType === "ACCOUNT_CREATION";
    },
    sealQualificationDisplay() {
      return this.workOrder.sealQualification || {};
    },
    accountCreationDisplay() {
      const ac = this.workOrder.accountCreation || {};
      const path = (ac.applyDeptNamePath || "").trim();
      const name = (ac.applyDeptName || "").trim();
      return {
        ...ac,
        applyDeptLabel: path || name,
      };
    },
    imgList() {
      return (
        (this.workOrder.attachVos &&
          this.workOrder.attachVos
            .filter((item) => item.attachmentType === "IMAGE")
            .map((item) => item.appendisUrl)) ||
        []
      );
    },
    fileList() {
      return (
        (this.workOrder.attachVos &&
          this.workOrder.attachVos
            .filter((item) => item.attachmentType === "FILE")
            .map((item) => {
              // const { appendisUrl: url } = item;
              // let fileName = url.split("-");
              // fileName.pop();
              // fileName = fileName.join("");
              // fileName = fileName.split("/");
              // fileName = fileName.pop();
              // return {
              //   fileName,
              //   url,
              // };
              return {
                fileName: item.appendisName,
                url: item.appendisUrl,
              };
            })) ||
        []
      );
    },
    chatList() {
      return (
        (this.workOrder.attachVos &&
          this.workOrder.attachVos.filter(
            (item) => item.attachmentType === "CONVERSATION",
          )) ||
        []
      );
    },
    showRemind() {
      return (
        this.workOrder.status === 0 &&
        ["work.mySubmit.detail", "workmange.workQuality.detail"].includes(
          this.$route.name,
        )
      );
    },
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
.image-list {
  width: 500px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
</style>
